import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import TagManager from 'react-gtm-module'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { createFirestoreInstance } from 'redux-firestore'

import {
    ThemeProvider,
    CssBaseline,
    createGenerateClassName,
    StylesProvider
} from '@material-ui/core'

import { NotificationProvider, ErrorBounder, InternetConnectionListener } from 'UI/Components'

import './index.css'
import theme from './app/theme'
import App from './App'

import { isDev, isLocalhost, envConfig } from 'modules'
import { store } from 'ducks/store'

//FullStory
import { init as initFullStory } from '@fullstory/browser'

//Sentry
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import SentryFullStory from '@sentry/fullstory'

initFullStory({ orgId: '15F24V', devMode: isDev })
const releaseName = process.env.REACT_APP_VERSION
Sentry.init({
    enabled: !isLocalhost,
    dsn: 'https://c72b354b5dce44a1bdeb51ea71e3cd01@o999875.ingest.sentry.io/5975512',
    integrations: [new Integrations.BrowserTracing(), new SentryFullStory('guiddeco')],
    environment: envConfig.firebaseConfig.environment,
    // for finer control
    tracesSampleRate: 0,
    release: releaseName,
    ignoreErrors: ['Non-Error promise rejection captured'] // https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-1233146122
})

Sentry.setTag('project-id', envConfig.firebaseConfig.projectId)

if (envConfig.firebaseConfig.projectId === 'guidde-production') {
    const tagManagerArgs = {
        gtmId: 'GTM-T74SSJN'
    }
    TagManager?.initialize(tagManagerArgs)
}

firebase.initializeApp(envConfig.firebaseConfig)
firebase
    .firestore()
    .settings({ experimentalForceLongPolling: true, ignoreUndefinedProperties: true })

const rrfProps = {
    firebase,
    config: {}, //rrfConfig,
    dispatch: store.dispatch,
    createFirestoreInstance
}

const generateClassName = createGenerateClassName({
    productionPrefix: 'guidde',
    disableGlobal: true,
    seed: 'web'
})

const root = createRoot(document.getElementById('root') as Element)

root.render(
    <ThemeProvider theme={theme}>
        <StylesProvider generateClassName={generateClassName}>
            <Provider store={store}>
                <ReactReduxFirebaseProvider {...rrfProps}>
                    <BrowserRouter>
                        <CssBaseline />
                        <NotificationProvider>
                            <InternetConnectionListener>
                                <ErrorBounder>
                                    <App />
                                </ErrorBounder>
                            </InternetConnectionListener>
                        </NotificationProvider>
                    </BrowserRouter>
                </ReactReduxFirebaseProvider>
            </Provider>
        </StylesProvider>
    </ThemeProvider>
)
